import * as actionTypes from "../actions/types/configurationActionTypes";
import { convertLanguageCulture } from "../../utils/helpers";
import { LOCAL_STORAGE_ITEMS } from "../../utils/constants";

export default function orderReducer(
  state = {
    showPreparationView:
      localStorage.getItem(LOCAL_STORAGE_ITEMS.SHOW_PREPARATION_VIEW) == null
        ? true
        : localStorage.getItem(LOCAL_STORAGE_ITEMS.SHOW_PREPARATION_VIEW) ===
          "true",
    showReadyToPickUpView:
      localStorage.getItem(LOCAL_STORAGE_ITEMS.SHOW_READY_TO_PICKUP_VIEW) ==
      null
        ? true
        : localStorage.getItem(
            LOCAL_STORAGE_ITEMS.SHOW_READY_TO_PICKUP_VIEW
          ) === "true",
    languageCode: localStorage.getItem(LOCAL_STORAGE_ITEMS.LANGUAGE) || "en",
    configurationMode: !localStorage.getItem(
      LOCAL_STORAGE_ITEMS.KITCHEN_SERVICE_URL
    ),
    kitchenConnectionUp: false,
    kitchenServiceAddress: localStorage.getItem(
      LOCAL_STORAGE_ITEMS.KITCHEN_SERVICE_URL
    )
  },
  action
) {
  switch (action.type) {
    case actionTypes.GET_LANGUAGE_SUCCEED: {
      action.data.languageCode = convertLanguageCulture(
        action.data.languageCode
      );
      localStorage.setItem(
        LOCAL_STORAGE_ITEMS.LANGUAGE,
        action.data.languageCode
      );
      return { ...state, ...action.data };
    }
    case actionTypes.GET_LANGUAGE_FAILED: {
      var language = localStorage.getItem(LOCAL_STORAGE_ITEMS.LANGUAGE);
      return { ...state, ...{ language } };
    }
    case actionTypes.SET_KITCHEN_CONNECTION_STATE: {
      state.kitchenConnectionUp = action.kitchenConnectionUp;
      return Object.assign({}, state);
    }
    case actionTypes.SAVE_CONFIGURATION: {
      state.configurationMode = false;
      state.kitchenServiceAddress = action.configuration.kitchenServiceAddress;
      state.showPreparationView = action.configuration.showPreparationView;
      state.showReadyToPickUpView = action.configuration.showReadyToPickUpView;

      localStorage.setItem(
        LOCAL_STORAGE_ITEMS.KITCHEN_SERVICE_URL,
        action.configuration.kitchenServiceAddress
      );
      localStorage.setItem(
        LOCAL_STORAGE_ITEMS.SHOW_PREPARATION_VIEW,
        action.configuration.showPreparationView
      );
      localStorage.setItem(
        LOCAL_STORAGE_ITEMS.SHOW_READY_TO_PICKUP_VIEW,
        action.configuration.showReadyToPickUpView
      );
      return Object.assign({}, state);
    }
    case actionTypes.TOGGLE_CONFIGURATION_MODE: {
      state.configurationMode = !state.configurationMode;
      return Object.assign({}, state);
    }
    default: {
      return Object.assign({}, state);
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/configurationReducer.js